export const customRound = (nb) => {
  return Math.round(nb * 100) / 100;
};
